import React, { Component, Fragment } from 'react';
// utils
import {Translations, convertStringToArray, convertStringToArrayForOption} from '../../../../utils';
// children
import NavListAccordion, {NavListAccordionWrapper} from '../../../common/NavListAccordion/NavListAccordion';

class EchannelListJSX extends Component {
  translateWord = (word) => {
    var currentWord = Translations(word,this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  render(){
    var eChannel = this.props.eChannels.filter(item => item.id === this.props.item.eChannelId)[0]
    return [
      <dt>{`${this.translateWord(this.props.pageJson.dynamic_accordion_list_accounts.fieldLabels)[22]} ${this.props.keyID + 1}`}</dt>,
      <dd>
      <b>{eChannel !==undefined? eChannel.eChannelType.name : ''}, {eChannel !==undefined? this.props.countryList !== undefined ? this.props.getCountryTaxonomy(eChannel).country.name: eChannel.country.name : ''}</b>
      <p>{eChannel !==undefined? eChannel.profileOwner.name : ''}</p>
      </dd>
    ]
  }
}

class NewAccounts extends React.Component{
  consturctor(props){

  }

  translateWord = (word) => {
    var currentWord = Translations(word,this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  renderEchannels=(eChannelsReporting)=>{
    let notOnlyGLSReportedEchannel = eChannelsReporting.map(echannel=>{
      if(echannel.productMap){
        if(Object.keys(echannel.productMap).length <=0){
          return echannel;
        }else{
          let returnEchannel = false;
          for(let [key,value] of Object.entries(echannel.productMap)){
            if(value==="Account"){
              returnEchannel = true;
              break;
            }
          }
          if(returnEchannel){
            return echannel;
          }
        }
      }else{
        if(!echannel.productMap)
          return echannel;
      }
      let returnEchannel = false;

    })
    .filter(item=> item || '');
    return notOnlyGLSReportedEchannel;
  }

  getProductRelatedTaxonomy(product){
    if (product !== undefined) {
       this.props.countryList.filter(countItem => {
          if ('country' in product) {
            if (countItem.id === product.country.value) {
              product.country.name = countItem.name
                if(product.accountType !== undefined){
                  countItem.associations.filter(accountType =>
                  {
                  if(accountType.id === product.accountType.value){
                    product.accountType.name = accountType.name
                      }
                  })
              }} }
        });
        return product;
}
}

  
getCountryTaxonomy=(item)=>{
  if(this.props.countryListForEchannel !== undefined){
            this.props.countryListForEchannel.filter(countItem => {
              if ('country' in item) {
                if (countItem.id === item.country.value) {
                  item.country.name = countItem.name
                  }
                }else{
                  if (countItem.id === item.value) {
                    item.name = countItem.name
                    }
                }
              })
              return item;
            }
    }

    getSalutation=(item)=>{
      var currentWord = Translations(this.props.pageJson.dynamic_accordion_list_customersInCase.salutation,this.props.lang.currentLang.lang, this.props.lang.translatedData)
      const salutation = convertStringToArrayForOption(currentWord);
    if(salutation !== undefined){
      salutation.filter(countItem => {
        if ('title' in item){
          if (countItem.split('=')[0]=== item.title.value) {
            item.title.name = countItem.split('=')[1] 
          } 
        }    
        })  
        return item;
    }
  }

  render(){
    const  {newAccounts , echannels, pageJson} = this.props;
    /*=================================newAccounts start================================================*/

    return (
      <div className="gdoc-preview-request-content">
      <span>
      {Translations(pageJson.dynamic_accordion_list_accounts.title,this.props.lang.currentLang.lang, this.props.lang.translatedData)}
      </span>
      <NavListAccordionWrapper>
          {newAccounts !== undefined && newAccounts.length > 0 ? newAccounts.map((item, key) => {
            let countryName = item.country.name;
            let translatedItem = this.props.countryList !== undefined
            ? this.getProductRelatedTaxonomy(item) : item;
            let paperStatementHeading = this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[30];
            if (paperStatementHeading !== undefined && countryName === 'Germany') {
              let statement = paperStatementHeading;
              let staArray = new Array();
              staArray = statement.split(" ");
              let germanStatement = staArray[0] + ' ' + staArray[1];
              paperStatementHeading = germanStatement;
            }

        const tabTitleHtml = (<div>
          <div className="Title">
          { item.accountType !== undefined &&  item.accountType.name !== undefined ? translatedItem.accountType.name+", " : ""}
          { item.country !== undefined ? translatedItem.country.name+", " : ""}
          { item.currency !== undefined ? item.currency.name : ""}
          </div>
          <div  className="SubTitle">
          { item.accountHolder !== undefined ? item.accountHolder.name+" " : ""}
          ({ item.country !== undefined ? translatedItem.country.name+" " : ""}
          { item.accountType !== undefined ? translatedItem.accountType.name : "''"})</div>
          </div>);



          /*=================================TabPanelContentBasicDetails start================*/
          const TabPanelContentBasicDetails = (
            <div className="basic-details-container">
            <div className = "basic-detail-heading">{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[8]}</div>
            <div className ="basic-detail-content">
            <dl className="dl-horizontal">
            <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[5]}</dt>
            <dd><b>{ item.accountHolder !== undefined &&  item.accountHolder.name !== undefined ? item.accountHolder.name : ""}</b></dd>
            <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[14]}</dt>
            <dd><b>{ item.country !== undefined &&  item.country.name !== undefined ? translatedItem.country.name : ""}</b></dd>
            <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[15]}</dt>
            <dd><b>{ item.residency !== undefined ? item.residency === true ? 'Resident' :'Non -Resident' :"" }</b></dd>
            <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[16]}</dt>
            <dd><b>{ item.accountType !== undefined && item.accountType.name !== undefined ? translatedItem.accountType.name :""}</b></dd>
            <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[17]}</dt>
            <dd><b>{ item.currency !== undefined && item.currency.name !== undefined ? item.currency.name : ""}</b></dd>
            <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[18]}</dt>
            <dd><b>{ item.tradingName !== undefined ? item.tradingName :""}</b></dd>
            <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[19]}</dt>
            <dd><b>{ item.preAllocated !== undefined ? item.preAllocated === true ? 'Yes' : 'No' : ""}</b></dd>
            {
              item.preAllocated !== undefined && item.preAllocated === true
              ? [
                  <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[33]}</dt>,
                  <dd><b>{item.accountNumber !== undefined && item.accountNumber !== '' ? item.accountNumber : ""}</b></dd>,
                  <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[34]}</dt>,
                  <dd><b>{item.branchCode !== undefined && item.branchCode !== '' ? item.branchCode :""}</b></dd>
                ]
              : ''
            }
            <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[20]}</dt>
            <dd><b>{ item.accountTitle !== undefined ? item.accountTitle : ""}</b></dd>
            </dl>
            </div>
            </div>
          );
          /*=================================TabPanelContentBasicDetails end==============================*/

          /*=================================TabPanelContentAccountAddressAndContacts start================*/
          const TabPanelContentAccountAddressAndContacts = (
            <div className="account-address-container">
            <div className = "account-address-heading">{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[25]}</div>
            <p>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[4]}</p>
            <div className ="account-address-content">
            <dl className="dl-horizontal">
            <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[6]}</dt>
            <dd><b>
            <span>
            { item.specificaddress !== undefined &&  item.specificaddress.addressLine1 !== undefined ? item.specificaddress.addressLine1+',' : ""}
            { item.specificaddress !== undefined &&  item.specificaddress.addressLine2 !== undefined ? item.specificaddress.addressLine2+',' : ""}
            { item.specificaddress !== undefined &&  item.specificaddress.addressLine3 !== undefined ? item.specificaddress.addressLine3+ ", " : ""}
            </span>
            <br/>
            <span>
            { item.specificaddress !== undefined &&  item.specificaddress.city !== undefined ? item.specificaddress.city+',' : ""}
            { item.specificaddress !== undefined &&  item.specificaddress.state !== undefined ? item.specificaddress.state+',' : ""}
            { item.specificaddress !== undefined &&  item.specificaddress.postCode !== undefined ? item.specificaddress.postCode+',' : ""}
            { item.specificaddress !== undefined &&  item.specificaddress.country !== undefined ? this.props.countryListForEchannel !== undefined? this.getCountryTaxonomy(item.specificaddress).country.name: item.specificaddress.country.name: ""}
            </span>
            </b></dd>
            <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[7]}</dt>
            <dd><b>{ item.forTheAttentionOf !== undefined ? item.forTheAttentionOf : ""}</b></dd>
            <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[26]}</dt>
            <dd>
              <b>{ item.accountSpecificContactDesignated !== undefined && item.accountSpecificContactDesignated === true ? 'Yes' : 'No'}</b>
            </dd>
            <dt>
                {
                   item.accountSpecificContactDesignated !== undefined && item.accountSpecificContactDesignated === true
                  ? this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[24]
                  : ""
              }
            </dt>
             {
                item.accountSpecificContactDesignated !== undefined && item.accountSpecificContactDesignated === true
               ? <dd>
                     <span>
                     { item.specificContact.title !== undefined &&  item.specificContact.title.name !== undefined ?  `${this.getSalutation(item.specificContact).title.name},` : ""}
                     { item.specificContact.other  !== undefined ? item.specificContact.other : ""} &nbsp;
                     { item.specificContact.firstName  !== undefined ? item.specificContact.firstName : ""}&nbsp;
                     { item.specificContact.lastName !== undefined ? `${item.specificContact.lastName},` : ""}
                     { item.specificContact.jobTitle !== undefined ? `${item.specificContact.jobTitle}` : ''}
                     </span> <br></br>
                  <span>
                  { item.specificContact.telephoneNumber !== undefined && item.specificContact.telephoneNumber !== ''? `Tel:${item.specificContact.telephoneNumber},` : ''}
                  </span>
                  <span>
                  { item.specificContact.faxNumber !== undefined ? `Fax:${item.specificContact.faxNumber}` : ''}
                  </span>

              </dd>
              :''}

            </dl>
            </div>
            </div>
          );
          /*=================================TabPanelContentAccountAddressAndContacts end=========================*/

          /*=================================Paperstatement start================*/
          const TabPanelContentPaperstatement = (
            <div className="basic-details-container">
            <div className = "basic-detail-heading">{paperStatementHeading}</div>
            <div className ="basic-detail-content">
            <dl className="dl-horizontal">
            {
              item.paperStatementChequeBooks !== undefined &&  item.paperStatementChequeBooks.paperStatementFrequency !== undefined &&  item.paperStatementChequeBooks.paperStatementFrequency.name !== undefined && item.paperStatementChequeBooks.paperStatementFrequency.value === 'NR'
              ? <Fragment>
                  <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[12]}</dt>
                  <dd><b>{ item.paperStatementChequeBooks !== undefined &&  item.paperStatementChequeBooks.paperStatementFrequency !== undefined &&  item.paperStatementChequeBooks.paperStatementFrequency.name !== undefined ? item.paperStatementChequeBooks.paperStatementFrequency.name : ""}</b></dd>
                </Fragment>
              : <Fragment>
                  <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[12]}</dt>
                  <dd><b>{ item.paperStatementChequeBooks !== undefined &&  item.paperStatementChequeBooks.paperStatementFrequency !== undefined &&  item.paperStatementChequeBooks.paperStatementFrequency.name !== undefined ? item.paperStatementChequeBooks.paperStatementFrequency.name : ""}</b></dd>

                  <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[3]}</dt>
                  <dd><b>{  item.paperStatementChequeBooks !== undefined &&  item.paperStatementChequeBooks.numberOfPaperStatements !== undefined &&  item.paperStatementChequeBooks.numberOfPaperStatements.name !== undefined ? item.paperStatementChequeBooks.numberOfPaperStatements.name : ''}</b></dd>

                  <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[27]}</dt>
                  <dd><b>{ item.paperStatementChequeBooks !== undefined &&  item.paperStatementChequeBooks.perfferedDate !== undefined ? item.paperStatementChequeBooks.perfferedDate : ""}</b></dd>

                  <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[11]}</dt>
                  <dd>
                  <span>
                  { item.paperStatementChequeBooks !==undefined &&  item.paperStatementChequeBooks.deliverToAddress !==undefined &&  item.paperStatementChequeBooks.deliverToAddress.addressLine1 !==undefined ?  item.paperStatementChequeBooks.deliverToAddress.addressLine1+", " : "" }
                  { item.paperStatementChequeBooks !==undefined &&  item.paperStatementChequeBooks.deliverToAddress !==undefined &&  item.paperStatementChequeBooks.deliverToAddress.addressLine2 !==undefined ?  item.paperStatementChequeBooks.deliverToAddress.addressLine2+", " : "" }
                  { item.paperStatementChequeBooks !==undefined &&  item.paperStatementChequeBooks.deliverToAddress !==undefined &&  item.paperStatementChequeBooks.deliverToAddress.addressLine3 !==undefined ?  item.paperStatementChequeBooks.deliverToAddress.addressLine3+ ", " : "" }
                  </span>
                  <br/>
                  <span>
                  { item.paperStatementChequeBooks !==undefined &&  item.paperStatementChequeBooks.deliverToAddress !==undefined &&  item.paperStatementChequeBooks.deliverToAddress.city !==undefined ?  item.paperStatementChequeBooks.deliverToAddress.city+ ", ": "" }
                  { item.paperStatementChequeBooks !==undefined &&  item.paperStatementChequeBooks.deliverToAddress !==undefined &&  item.paperStatementChequeBooks.deliverToAddress.state !==undefined ?  item.paperStatementChequeBooks.deliverToAddress.state+ ", " : "" }
                  { item.paperStatementChequeBooks !==undefined &&  item.paperStatementChequeBooks.deliverToAddress !==undefined &&  item.paperStatementChequeBooks.deliverToAddress.postCode !==undefined ?  item.paperStatementChequeBooks.deliverToAddress.postCode+ ", " : "" }
                  { item.paperStatementChequeBooks !==undefined &&  item.paperStatementChequeBooks.deliverToAddress !==undefined &&  item.paperStatementChequeBooks.deliverToAddress.country !==undefined ?  this.props.countryListForEchannel !== undefined? this.getCountryTaxonomy(item.paperStatementChequeBooks.deliverToAddress).country.name: item.paperStatementChequeBooks.deliverToAddress.country.name: "" }
                  </span>
                  </dd>
                  <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[7]}</dt>
                  <dd><b>{ item.paperStatementChequeBooks !== undefined &&  item.paperStatementChequeBooks.attentionOf !== undefined ? item.paperStatementChequeBooks.attentionOf : ""}</b></dd>

                  <dt>{item.paperStatementChequeBooks !==undefined && item.paperStatementChequeBooks.chequeBookTypes !==undefined && item.paperStatementChequeBooks.chequeBookTypes.name !=='' && item.paperStatementChequeBooks.chequeBookTypes.name !== undefined ? this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[29] :''}</dt>
                  <dd>{ item.paperStatementChequeBooks !==undefined &&  item.paperStatementChequeBooks.chequeBookTypes !==undefined &&  item.paperStatementChequeBooks.chequeBookTypes.name !== undefined  && item.paperStatementChequeBooks.chequeBookTypes.name !=='' ?  item.paperStatementChequeBooks.chequeBookTypes.name : "" }</dd>

                  <dt>{item.paperStatementChequeBooks !==undefined &&  item.paperStatementChequeBooks.numberOfChequeBooks !==undefined &&  item.paperStatementChequeBooks.numberOfChequeBooks.name !== undefined ? this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[21] : ''}</dt>
                  <dd>{ item.paperStatementChequeBooks !==undefined &&  item.paperStatementChequeBooks.numberOfChequeBooks !==undefined &&  item.paperStatementChequeBooks.numberOfChequeBooks.name !== undefined ?  item.paperStatementChequeBooks.numberOfChequeBooks.name : "" }</dd>
                </Fragment>
            }
            </dl>
            </div>
            </div>
          );
          /*=================================Paperstatement end==============================*/

          /*=================================AccountSignatories start================*/
          const TabPanelContentAccountSignatories = (
            <div className="basic-details-container">
            <div className = "basic-detail-heading">{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[31]}</div>
            <div className ="basic-detail-content">
            <dl className="dl-horizontal">
            <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[1]}</dt>
            <dd>
            { item.mandateStructure !== undefined && item.mandateStructure.value === 'any-2-to-sign' ? <b>Any two to sign</b> :"" }
            { item.mandateStructure !== undefined && item.mandateStructure.value === 'any-1-to-sign' ? <b>Any one to sign</b> :"" }
            { item.mandateStructure !== undefined && item.mandateStructure.value === 'group-signature' ? <b>Signature Grouping</b> :"" }
            { item.mandateStructure !== undefined && item.mandateStructure.value === 'own-mandate' ? <b>I will attach my own mandate</b> :"" }
            </dd>
            </dl>
            { item.accountSignatory !== undefined && item.accountSignatory.length > 0 ? item.accountSignatory.map((childData,key) =>
            <dl className="dl-horizontal" key={key}>
            <dt>{`${this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[9]} ${key+1}`}</dt>
            <dd>
            <b>
              {
                childData !== undefined &&  childData.firstName !== undefined
                ? `${childData.firstName},` : ""
              }
              {
                childData !== undefined &&  childData.lastName !== undefined
                ?  `${childData.lastName}`
                : ""
              }
              {
                childData.countryOfResidence !== undefined &&  childData.countryOfResidence.name !== undefined
                ? `,${childData.countryOfResidence.name}`
                : ""
              }
              { childData !== undefined &&  childData.dateOfBirth !== undefined
                ? `,${childData.dateOfBirth}`
                : ""
              }
            </b>
            </dd>
            <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[2]}</dt>
            <dd>
            <b>
            {
               item.accountSignatories[key] !== undefined &&  item.accountSignatories[key].restriction !== undefined
               ? item.accountSignatories[key].restriction
               : ""
             }
             </b>
             </dd>
            </dl>
            ) : ""}

            </div>
            </div>
          );
          /*=================================AccountSignatories end==============================*/

          /*=================================EchannelsReports start================*/
          const TabPanelContentEchannelsReports = (
            <div className="basic-details-container">
            <div className = "basic-detail-heading">{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[32]}</div>
            <div className ="basic-detail-content">
            <dl className="dl-horizontal">
            <dt>{this.translateWord(pageJson.dynamic_accordion_list_accounts.fieldLabels)[0]}</dt>
            <dd>
            <b>{ item.reportToEchannel !== undefined ? item.reportToEchannel === true ? "Yes" : "No" :""}</b>
            </dd>
            {
              this.renderEchannels(item.eChannelReporting).map((item,key) =>
                <EchannelListJSX
                  item={item}
                  eChannels={echannels}
                  keyID={key}
                  pageJson={this.props.pageJson}
                  lang={this.props.lang}
                  countryList={this.props.countryListForEchannel}
                  getCountryTaxonomy={(item) => this.getCountryTaxonomy(item)}
                />
              )
            }
            </dl>
            </div>
            </div>
          );
          /*=================================AccountSignatories end==============================*/
          return (
            <NavListAccordion navAccHeading={tabTitleHtml} key={key}>
            <div className="basic-details-section">
            {TabPanelContentBasicDetails}
            <span className="basic-details-section-bar"></span>
            {TabPanelContentAccountAddressAndContacts}
            <span className="basic-details-section-bar"></span>
            {item.paperStatementChequeBooks !==undefined? TabPanelContentPaperstatement :''}
            <span className="basic-details-section-bar"></span>
            {TabPanelContentAccountSignatories}
            <span className="basic-details-section-bar"></span>
            {TabPanelContentEchannelsReports}
            </div>
            </NavListAccordion>
          )
        }) : "" }
        </NavListAccordionWrapper>
        </div>
      )
    }
    /*=================================newAccounts end========================================================================*/
  }
  export default NewAccounts;



// WEBPACK FOOTER //
// ./src/components/CaseBody/PreviewRequest/Child/NewAccounts.js